import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EventsService } from '@osapp/modules/events/events.service';
import { LoggerService } from '@osapp/modules/logger/services/logger.service';
import { ApplicationService } from '@osapp/services/application.service';
import { FlagService } from '@osapp/services/flag.service';
import { GlobalDataService } from '@osapp/services/global-data.service';
import { PlatformService } from '@osapp/services/platform.service';
import { EProfession } from '../model/EProfession';

@Injectable({ providedIn: "root" })
export class IdlApplicationService extends ApplicationService {

	//#region FIELDS

	/** Identifiant du descripteur de formulaire pour un patient. */
	public static readonly C_PATIENTS_BOOK_FORMDESC_ID = `formDesc_patientsBook`;
	/** Identifiant de la définition de formulaire pour l'édition d'un patient. */
	public static readonly C_PATIENTS_BOOK_FORMDEF_ID_EDIT = "patient_edit";
	/** Identifiant de la définition de formulaire pour le visu d'un patient. */
	public static readonly C_PATIENTS_BOOK_FORMDEF_ID_VISU = "patient_visu";
	/** Tableau des lettre-clés des actes qui sont éligibles à l'IFI. */
	public static readonly C_IFI_ELIGIBLE_KEY_LETTERS = ["BSA", "BSB", "BSC"];

	//#endregion

	//#region PROPERTIES

	/** Profession séléctionnée par l'utilisateur. Tant qu'il n'y a pas d'autre métiers, valeur mise en dur. */
	public profession?: EProfession = EProfession.idel;

	//#endregion

	//#region METHODS

	constructor(
		psvcFlag: FlagService,
		psvcEvents: EventsService,
		psvcPlatform: PlatformService,
		psvcLogger: LoggerService,
		psvcGlobalData: GlobalDataService,
		poRouter: Router) {
		super(psvcFlag, psvcEvents, psvcPlatform, psvcLogger, psvcGlobalData, poRouter);
		this.waitInitDatabasesToCreateDatabaseDocuments();
	}

	/** Attend la fin de l'initialisation des bases de données pour demander la création des design documents. */
	protected waitInitDatabasesToCreateDatabaseDocuments(): void { }
	

	//#endregion
}
